import type { LinkedProgramPreview } from "@brookbush/types";

import Link from "next/link";

import { camelToTitle } from "~/utils/helpers";

const LinkedProgramCard = ({ program }: { program: LinkedProgramPreview }) => {
	return (
		<div className="flex flex-col gap-4 phablet:gap-2 rounded-[0.9rem] border border-orange-800/20 bg-orange-50 phablet:px-5 px-4 phablet:py-3 py-2 shadow shadow-orange-800/10 dark:border-orange-300/40 dark:bg-orange-300/20">
			<div className="flex w-full flex-col gap-1">
				<p className="text-orange-800 text-sm dark:text-orange-100">
					Sample Program
				</p>

				<p className="font-medium">{program.name}</p>

				{program.stats.phaseCount !== undefined && (
					<p>{program.stats.phaseCount} phases</p>
				)}

				<div className="flex gap-2 text-sm">
					<p>{camelToTitle(program.type)}</p>·
					<p>{program.stats.exerciseCount} exercises</p>
				</div>
			</div>

			<Link
				target="_blank"
				href={`/programs/${program.id}`}
				className="my-1.5 rounded-full bg-orange-100 px-4 py-1.5 text-center text-orange-900 transition-colors hover:bg-orange-200/50 dark:bg-orange-300/20 dark:text-orange-100 dark:hover:bg-orange-300/30"
			>
				View Sample Program
			</Link>
		</div>
	);
};

export default LinkedProgramCard;
